/** Brand logo — uses the official NVL logo PNG. */
export function BrandMark({ size = 34 }) {
  return (
    <span
      className="inline-block flex-shrink-0"
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <img src="/nvl-logo.png" alt="Nikhil Vatika Lab" width={size} height={size} style={{ width: size, height: size, objectFit: "contain", display: "block" }} />
    </span>
  );
}

export function Brand({ size = 38 }) {
  return (
    <div className="flex items-center gap-3 flex-shrink-0" data-testid="brand-logo">
      <BrandMark size={size} />
      <b className="font-display font-semibold text-[20px] tracking-[0.01em] whitespace-nowrap leading-none">
        Nikhil Vatika Lab
      </b>
    </div>
  );
}
